<span *ngFor="let item of items" class="boxed-value">
	{{ item!.displayName || item }}
</span>
